import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';
import {User} from '../../../modules/main/types/users.types';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    // Observables
    private _user: BehaviorSubject<User | null>;

    private url = environment.apiUrl;

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient
    ) {
        // Set the defaults
        this._user = new BehaviorSubject(null);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user(): User {
        return this._user.getValue();
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user data
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch(this.url + '/api/profile/me', user)
            .pipe(
                tap(res => {
                    if (res.data) {
                        this._user.next(res.data);
                    }
                })
            );
    }

    loadUser(): Observable<any> {
        return this._httpClient.get(this.url + '/api/profile/me').pipe(
            map(res => {
                this._user.next(res['data']);
                return res['data'];
            })
        );
    }

    removeUser(): void {
        this._user.next(null);
    }
}
